import { FunctionComponent } from 'react'
import {
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import { navItems } from './nav-items'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

const StyledLink = styled(ListItem)({
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '20px',
  padding: 0,
  cursor: 'pointer',
  '&:first-of-type': {
    fontWeight: '500',
    cursor: 'default',
  },
})

const MainLink = styled(ListItem)({
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  padding: 0,
  cursor: 'pointer',
  '&:not(:last-child)': {
    marginBottom: '4px',
  },
})

interface Props {
  bg: string
  color: string
}

export const CustomAccordion: FunctionComponent<Props> = ({ bg, color }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <>
      {navItems.map((nav, index) => {
        const hasChildren = !!nav.subItems?.length

        if (hasChildren) {
          return (
            <Accordion
              key={index}
              elevation={0}
              sx={{
                '&:before': {
                  display: 'none',
                },
                display: {
                  md: 'block',
                  lg: 'none',
                },
              }}
            >
              <AccordionSummary
                id={nav.title}
                sx={{
                  backgroundColor: bg,
                  boxShadow: 'none',
                  color,
                }}
                expandIcon={
                  <AddIcon
                    sx={{
                      color,
                    }}
                  />
                }
              >
                {t(nav.id)}
              </AccordionSummary>
              {nav.subItems?.map((subNav) => {
                return (
                  <AccordionDetails
                    key={subNav.path}
                    sx={{
                      backgroundColor: bg,
                      border: 'none',
                      color,
                    }}
                  >
                    <StyledLink
                      key={subNav.title}
                      onClick={() => navigate(subNav.path)}
                      sx={{
                        color: `${color} !important`,
                      }}
                    >
                      {t(subNav.id)}
                    </StyledLink>
                  </AccordionDetails>
                )
              })}
            </Accordion>
          )
        }

        return (
          <MainLink
            key={nav.title}
            onClick={() => navigate(nav.path)}
            sx={{
              color: `${color} !important`,
            }}
          >
            {t(nav.id)}
          </MainLink>
        )
      })}
    </>
  )
}
